import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Text } from '../Text/Text';
import { COLORS, device, FONTS, ROUTES } from '../../constants';
import { ArrowRed } from '../../assets/svg';
import { TUpdatesVisualMode } from './Updates';

interface UpdatesItemProps {
  name: string;
  visualMode: TUpdatesVisualMode;
  onLinkClick?: () => void;
}

export const UpdatesItem = ({
  name,
  visualMode,
  onLinkClick,
}: UpdatesItemProps) => {
  const { t } = useTranslation();

  return (
    <UpdatesItemContainer>
      <UpdateContentWrapper>
        <TextWrapper>
          <Text
            text={t('screen.portfolio.updates.newProjectAdded')}
            fontFamily={FONTS.SUBTITLE}
            size={22}
            lineHeight={28}
            color={COLORS.SECTION_TEXT}
          />
        </TextWrapper>
        {visualMode === 'page' && (
          <TextWrapper>
            <Text
              text={name}
              fontFamily={FONTS.SUBTITLE}
              size={22}
              lineHeight={28}
              color={COLORS.SECTION_TEXT}
            />
          </TextWrapper>
        )}
        <UpdateLink
          to={`${ROUTES.PROJECT}/${name?.replace(/\s+/g, '_')}`}
          onClick={onLinkClick}
        >
          <Text
            text={t('screen.portfolio.updates.viewCase')}
            fontFamily={FONTS.SUBTITLE}
            size={22}
            lineHeight={28}
            color={COLORS.MAIN_RED}
          />
          <ArrowRed />
        </UpdateLink>
      </UpdateContentWrapper>
    </UpdatesItemContainer>
  );
};

const UpdatesItemContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 13px;
`;

const UpdateContentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  @media screen and ${device.md} {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

const UpdateLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 20px;
  text-decoration: none;
  color: ${COLORS.MAIN_RED};
  font-family: ${FONTS.SUBTITLE};

  @media screen and ${device.md} {
    margin-top: 8px;

    > h4 {
      font-size: 16px;
      line-height: 1.15;
    }
`;

const TextWrapper = styled.div`
  @media screen and ${device.md} {
    > h4 {
      font-size: 16px;
      line-height: 1.15;
    }
`;
